import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';

export interface SectionItem {
  id: string;
  link: Link;
  selected: boolean;
}

export interface Section {
  id: string;
  title: string;
  items: SectionItem[];
  url: string;
  opened: boolean;
}

export interface Current {
  label: string;
  url: string;
  toggle: boolean;
}

export interface SectionHeader {
  url: string;
  totalItems: number;
}

export enum SCREEN_WIDTH {
  MOBILE = 1200,
  MEDIUM = 992
}

export interface Menu extends DisplayProperties {
  sections: Section[];
}
